__turbopack_context__.v({
  "columns": "ColumnsSection-module-scss-module__wzTu9G__columns",
  "columnsSection": "ColumnsSection-module-scss-module__wzTu9G__columnsSection",
  "grid": "ColumnsSection-module-scss-module__wzTu9G__grid",
});
